import React, {useState} from "react";
import {CardBody, Col, Form, FormGroup, Label, Row} from "reactstrap";
import {connect} from "react-redux";
import {useForm} from "react-hook-form";


// components
import SelectGeneric from "../../../components/select/selectGeneric";
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";

// labels
import {LB_AIRLINE, LB_AIRPORT, LB_DESTINY, LB_ORIGIN, LB_SERVICE, UDN} from "../../../components/i18n/i18n";

// actions
import {setFilter} from "../../../redux/actions/generalActions/listActions";

// providers
import {wishlistServiceProvider} from "../../../providers/wishlist/wishlistServicesProvider";
import {wishlistTypes} from "../../../util/WishlistUtils";
import {udnProvider} from "../../../providers/udnProvider";
import {airlineProvider} from "../../../providers/airlineProvider";
import {airportProvider} from "../../../providers/hotel/airportProvider";



const WishlistSalesforceFilters = (props) => {
    const { app } = props.mainProps;
    const { filter } = props.listProps

    const fbDataBase = {id: app?.fbDataBase?.id}

    const [servicio, setServicio] = useState(filter?.servicio || null);
    const [idOrigen, setIdOrigen] = useState(filter?.idOrigen || null);
    const [idDestino, setIdDestino] = useState(filter?.idDestino || null);

    const {handleSubmit, reset} = useForm({
        defaultValues: {
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase,
            item : {
                ...data,
                servicio,
                idOrigen,
                idDestino
            }
        };

        props.setFilter(dataFilter);
    };

    const cleanFields = () => {
        reset({});
        setServicio(null)
        setIdOrigen(null)
        setIdDestino(null)
    }

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>{LB_SERVICE}</Label>
                        <SelectGeneric
                            provider={ wishlistServiceProvider }
                            initialValue={ servicio }
                            setExternalValue={ setServicio }
                        />
                    </FormGroup>
                </Col>
                {
                    servicio === wishlistTypes.transportation.description && <>
                        <Col md="4">
                            <FormGroup>
                                <Label>{UDN} ({LB_ORIGIN})</Label>
                                <SelectGeneric
                                    provider={ udnProvider }
                                    initialValue={ idOrigen }
                                    setExternalValue={ setIdOrigen }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{LB_AIRPORT} ({LB_DESTINY})</Label>
                                <SelectGeneric
                                    provider={ airportProvider }
                                    initialValue={ idDestino }
                                    setExternalValue={ setIdDestino }
                                />
                            </FormGroup>
                        </Col>
                    </>
                }
                {
                    servicio === wishlistTypes.afi.description && <>
                        <Col md="4">
                            <FormGroup>
                                <Label>{UDN} ({LB_ORIGIN})</Label>
                                <SelectGeneric
                                    provider={ udnProvider }
                                    initialValue={ idOrigen }
                                    setExternalValue={ setIdOrigen }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{UDN} ({LB_DESTINY})</Label>
                                <SelectGeneric
                                    provider={ udnProvider }
                                    initialValue={ idDestino }
                                    setExternalValue={ setIdDestino }
                                />
                            </FormGroup>
                        </Col>
                    </>
                }


                <Col sm={12} className={'d-flex justify-content-center'}>
                    <div className="float-right ">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>

    </Form>
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(WishlistSalesforceFilters)